<template>
<v-app>
<v-main>

    <div
        style="text-align: center; margin-top: 30px; margin-bottom: 30px;"
    >
        <img
            src="@/assets/redchirp-logo-square-center.png"
            style="width: 200px"
        />

    </div>

    <v-container>
        <div
            v-if="submitted"
            style="text-align: center"
        >
            <h1>Thank you!</h1>
            <br/><br/>
            <p>We will use the credentials you provided to configure your integration.</p>
            <p>We will be in touch with you shortly.</p>
            <p>Happy Chirping!</p>
        </div>

        <div
            v-else
        >
            This form allows you to <b>securely</b> provide RedChirp with {{secret_type_description}}.

            <integration-api-docs
                :integration_type="$route.params.secret_type"
            />
            
            <v-text-field
                label="Organization"
                v-model="for_organization_label"
                :hint="'The name of the organization that the '+secret_type_description+' are for'"
                persistent-hint
            />

            <v-text-field
                v-if="tenant_description != null"
                :label="tenant_description"
                v-model="tenant"
            />

            <v-text-field
                v-if="username_description != null"
                :label="username_description"
                v-model="username"
            />

            <v-text-field
                v-if="password_description != null"
                :label="password_description"
                v-model="password"
            />

            <v-row>
                <v-col>
                    <v-text-field
                        label="Your First Name"
                        v-model="first_name"
                    />
                </v-col>

                <v-col>
                    <v-text-field
                        label="Your Last Name"
                        v-model="last_name"
                    />
                </v-col>
            </v-row>

             <v-alert
                :value="show_alert"
                color="primary"
                type="error"
            >
                {{alert_text}}
            </v-alert>

            <div
                style="text-align: right"
            >
                <v-btn
                    color="primary"
                    v-on:click="onClickSubmit"
                >
                    Submit
                </v-btn>
            </div>
        </div>



    </v-container>


</v-main>


  <m-global-spinner/>
  <m-global-snackbar/>
  <m-global-alert/>
  <m-global-confirm/>
  <m-global-prompt/>

</v-app>
</template>

<script>
import IntegrationApiDocs from '@/views/integrations/integration-api-docs.vue';

export default {
    components: {
        IntegrationApiDocs
    },

    data() {
        return {
            first_name: null,
            last_name: null,
            for_organization_label: null,
            username: null,
            password: null,
            tenant: null,
            submitted: false,
            show_alert: false,
            alert_text: null,
        }
    },

    methods: {
        onClickSubmit() {

            this.show_alert = false;

            if ( this.isEmpty(this.for_organization_label) )
            {
                this.show_alert = true;
                this.alert_text = "Please enter your organization name";
                return;
            }

            if ( this.isEmpty(this.username) && this.username_description != null )
            {
                this.show_alert = true;
                this.alert_text = 'Please enter your '+this.username_description;
                return;
            }

            if ( this.isEmpty(this.password) && this.password_description != null )
            {
                this.show_alert = true;
                this.alert_text = "Please enter your "+this.password_description;
                return;
            }

            let secret = {};

            if ( this.username_description != null )
                secret[this.username_description] = this.username;

            if ( this.password_description != null )
                secret[this.password_description] = this.password;

            if ( this.tenant != null )
            {
                secret[this.tenant_description] = this.tenant;
            }

            let params = {
                        'type': this.$route.params.secret_type,
                        'for_organization_label': this.for_organization_label,
                        'first_name': this.first_name,
                        'last_name': this.last_name,
                        'secret': secret,
                    };

            this.$rc.rest({
                'spinner': true,
                'endpoint': 'PUT: /api/v1/secrets',


                'params' : params,

                'on_success': (data) => {
                        this.submitted = true;
                    },

                'on_error': 'Unable to submit your '+this.secret_type_description,
            });


        },

        isEmpty(value)
        {
            if ( value == null ) return true;
            if ( value.trim().length == 0 ) return true;
            return false;
        }
    },

    computed: {
        secret_type() {
            return this.$route.params.secret_type;
        },

        secret_type_description() {
            return this.$rc.pretty(this.$route.params.secret_type, 'enum_secret_type');
        },

        username_description() {
            let secret_type = this.$route.params.secret_type;

            if ( secret_type == 'wine-direct-credentials' ) return 'WineDirect API Username';
            if ( secret_type == 'wine-direct-fulfillment-credentials' ) return 'WineDirect Fulfillment Rest API Username';
            if ( secret_type == 'ecellar-credentials' ) return 'eCELLAR Rest API Username';
            if ( secret_type == 'tock' ) return 'Business ID';
            if ( secret_type == 'vinsuite' ) return 'Username';
            if ( secret_type == 'bottle360' ) return 'Dedicated Bottle360 system user\'s username';
            if ( secret_type == 'vinoshipper' ) return 'API Key';

            return null;
        },

        password_description() {
            let secret_type = this.$route.params.secret_type;

            if ( secret_type == 'wine-direct-credentials' ) return 'WineDirect API Password';
            if ( secret_type == 'wine-direct-fulfillment-credentials' ) return 'WineDirect Fulfillment Rest API Password';
            if ( secret_type == 'wine-direct-big-commerce-credentials' ) return 'The ANWD WineDirect access token';
            if ( secret_type == 'ecellar-credentials' ) return 'eCELLAR Rest API Password';
            if ( secret_type == 'tock' ) return 'API Key';
            if ( secret_type == 'vinsuite' ) return 'Password';
            if ( secret_type == 'vines-os' ) return 'API Key / Password';
            if ( secret_type == 'offset' ) return 'API Key / Password';
            if ( secret_type == 'bottle360' ) return 'Dedicated Bottle360 system user\'s password';
            if ( secret_type == 'copper-peak' ) return 'InfoPlus WMS API Key';
            if ( secret_type == 'vinoshipper' ) return 'API Secret';
            if ( secret_type == 'corksy' ) return 'API Key';

            return null;
        },

        tenant_description() {
            let secret_type = this.$route.params.secret_type;

            if ( secret_type == 'wine-direct-fulfillment-credentials' ) return 'WineDirect Fulfillment Account Number';
            if ( secret_type == 'wine-direct-big-commerce-credentials' ) return 'The ANWD store hash (eCommerce > Settings > URL will read https://store-[store-hash].mybigcommerce.com/manage/settings-list)';
            if ( secret_type == 'tock' ) return 'Business Group ID';
            if ( secret_type == 'vines-os' ) return 'Domain for VinesOS hosted site, e.g. redchirp.vinesos.com or www.redchirp.com';
            if ( secret_type == 'commerce7-tenant-activation' ) return 'The Commerce7 tenant name, e.g. joseph-cellars-winery';
            if ( secret_type == 'bottle360' ) return 'Tenant Name (your winery name as it appears in your Bottle360 URL, e.g. "joeswinery" for https://joeswinery.bottlethreesixty.com)';
            return null;
        },
    },
}
</script>

<style lang="scss" scoped>
</style>

